module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-stone-path.a7de0a5a.png";